<template>
  <div class="animated fadeIn">
    <b-row class="py-2">
      <b-card header="Crear Tipo de Campaña" class="w-100">
        <b-form @submit.prevent="store" enctype="multipart/form-data">
          <b-row class="px-3">

            <b-form-group
              label="<strong>Nombre *</strong>"
              label-for="name"
              :horizontal="false" class="w-100">
              <b-form-input id="name" type="text" placeholder="Nombre" v-model="campaign.name" required></b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <div class="col float-left">
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                v-if="mixinCheckPermission('CAMPAIGN_TYPE_NEW')">
                Guardar
              </button>
            </div>
          </b-row>

        </b-form>
      </b-card>
    </b-row>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import {getDistributions} from "@/api/distribution-list-api";

export default {

  name: 'addCampaignType',
  components: {
    Multiselect
  },
  data: function () {
    return {
      topmenu: [
        { name: 'Volver', path: '/communications/campaign-type/list', brand:'fa fa-arrow-left'},
      ],
      campaign: {
        name: null
      }
    }
  },

  mounted(){
    this.$eventHub.$emit('captureMenu', this.topmenu);
    this.uuid = this.$route.params.uuid;
    this.typeOfTemplate = this.$route.query.typeOfTemplate;
  },

  methods: {
    async store(){
      let properties = Object.assign({}, this.campaign);
      axios.post('campaign-type', properties)
        .then((response) => {
          this.$_loadingMixin_hideLoading();
          if (response.status === 201) {
            this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
            this.$router.push({path: '/communications/campaign-type/list'});
          }
        })
        .catch((error) => {
          this.$_loadingMixin_hideLoading();
          this.showApiError(error.response);
        });
    },
    requirements(){
      if(!this.campaign.name){
        return false;
      }else{
        return true;
      }
    },
  },
}
</script>
